module.exports = __webpack_public_path__ + "img/customer_3_de.56095c10.png";